{
    "cookie_consent_title": "Háliidatgo oaidnit dán sisdoalu?",
    "cookie_consent_button": "Raba njuolggadusa válljemiid",
    "cookie_consent_description": {
        "type": "markdown",
        "value": "Jus galgat sáhttit čájehit video, de mii dárbbašit du mieđiheami."
    },
    "playVideo": "Čájet video",
    "hearVisualInterpretation": "Guldal oaidnodulkoma videos.",
    "doneVisualInterpretation": "Oaidnodulkon video bokte lea lohkkojuvvon."
}
